import React from 'react';
import {useSelector} from "react-redux";
import {useTranslate} from "../../../system/useTranslate";
import Icon from "../../../system/components/icon";
import SelectMember from "./select-member";
import {MultiSelect} from "primereact/multiselect";
import SelectZofinoDateTime from "./select-zofino-datetime";
import SelectTaskType from "./select-task-type";
import {createDefaultRecurrence} from "./task-recurrence-model";

function TaskToolbar({taskData, setTaskData, miniToolbar, assignee=true, project=true, datetime=true, taskType=true}) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const translate = useTranslate();
    function ItemTemplate(option) {
        return(
            <div className="flex align-items-center border-noround justify-content-between px-2 cursor-pointer">
                <div className="flex gap-2 align-items-center">
                    <div className="flex flex-column">
                        {option?(
                            <span className="text-xs">{option?.title}</span>
                        ):(
                            <div className="flex align-items-center gap-1">
                                <Icon icon="mi mi:folder_open" className="text-lg"/>
                                <span className="text-xs">{translate("projects")}</span>
                            </div>

                        )}

                        {/*<span className="text-xs text-300">{}</span>*/}
                    </div>
                </div>

                {/*{option.value>0&&<i className="pi pi-chevron-left text-xs"/>}*/}
            </div>
        )
    }

    return(
        <div className="flex gap-2 align-items-end">
            {
                assignee&&(
                    <div className="border-1 border-300 border-dashed border-round-3xl px-2">
                        <SelectMember label={!miniToolbar&&translate("select-assignee")} hideLabel={miniToolbar} selectedMember={taskData?.assignee} onChange={(membership)=>{setTaskData({...taskData, assignee: membership})}} members={workspaceMembershipData?.workspace.workspace_memberships || []} />
                    </div>
                )
            }
            {
                project&&(
                    <div className="border-1 border-300 border-dashed border-round-3xl px-2">
                        <MultiSelect pt={{input:()=>({className:"p-1"}),root:()=>({className:"p-2"}),label:()=>({className:"text-xs"})}} itemTemplate={ItemTemplate} selectedItemTemplate={ItemTemplate} dropdownIcon={<Icon icon="mi mi:keyboard_arrow_down" className="text-lg"/>} collapseIcon={<Icon icon="mi mi:keyboard_arrow_up" className="text-lg"/>} showSelectAll={false} panelHeaderTemplate={<></>} itemClassName="rtl" value={taskData?.projects} onChange={(e) => {setTaskData({...taskData, projects:e.value})}} options={workspaceMembershipData?.workspace.projects} optionLabel="title" maxSelectedLabels={1} selectedItemsLabel={translate("projects-selected").replace("{{COUNT}}", taskData?.projects?.length)} className="border-none shadow-none"  />
                    </div>
                )
            }
            {datetime&&(
                <div className="border-1 border-300 border-dashed border-round-3xl px-2">
                    <SelectZofinoDateTime enableRecurrence hideLabels={miniToolbar} range selectedDateTime={{start:taskData?.startAt, end:taskData?.dueDate}} recurrence={taskData?.recurrence || createDefaultRecurrence()} onRecurrenceChange={(recurrence)=>{setTaskData((current)=>({...current, recurrence}))}} onChange={(e)=>{setTaskData({...taskData, startAt:e.start?.toUnix(), dueDate:e.end?.toUnix()})}}/>
                </div>
            )}
            {taskType&&(
                <div className="border-1 border-300 border-dashed border-round-3xl px-2">
                    <SelectTaskType selectedTaskType={taskData?.task_type} taskTypes={workspaceMembershipData?.workspace.task_types} onChange={(e)=>{setTaskData({...taskData, task_type:e?.id?e:null}) }}/>
                </div>
            )}

        </div>
    )
}


export default TaskToolbar;
